import {ApiContent} from '../../../application/contentLoaders/apiContent';

class SearchContent extends ApiContent {
    /**
     * @param {string} endpoint
     * @param {string} searchQuery
     * @param {CallableFunction} loadedCallback
     */
    constructor(endpoint, searchQuery, loadedCallback) {
        super(endpoint, {query: searchQuery}, loadedCallback);
    }

    /**
     * @param {string} result.url
     * @param {string} result.name
     * @param {string} result.alias
     * @param {string} result.image
     * @param {Object} result
     * @returns {string}
     */
    formatResultTemplate(result) {
        return `<div class="brands-item">
            <a class="brands-item-img" href="${result.url}">
                <img width="124" height="88" src="${result.image}" loading="lazy" alt="${result.name}" title="${result.name}">
            </a>
            <div class="brands-item-name">
                <a href="${result.url}">${result.name}</a>
            </div>
        </div>`;
    }
}

export {SearchContent};
